<template>
  <v-main fluid>
    <v-card class="mt-2">
      <v-card-title>微信模板消息发送</v-card-title>
      <v-card-text>
        <v-text-field dense v-model="wxMsgParam.id" outlined label="模板id"></v-text-field>
        <v-text-field dense v-model="wxMsgParam.openId" outlined label="openId"></v-text-field>
        <v-textarea dense v-model="wxMsgParam.param" outlined label="模板参数"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="onSendWxMsg" color="primary">提交</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-card-title>短信模板消息发送</v-card-title>
      <v-card-text>
        <v-text-field dense v-model="smsParam.id" outlined label="模板id"></v-text-field>
        <v-text-field dense v-model="smsParam.phone" outlined label="手机号"></v-text-field>
        <v-textarea dense v-model="smsParam.param" outlined label="模板参数"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="onSendSms" color="primary">提交</v-btn>
      </v-card-actions>
    </v-card>
  </v-main>
</template>
<script>
import { magicSendWxMsg, magicSendSms } from '@/plugins/api'
export default {
  data () {
    return {
      wxMsgParam: { id: '', openId: '', param: '' },
      smsParam: { id: '', phone: '', param: '' }
    }
  },
  methods: {
    onSendWxMsg () {
      magicSendWxMsg(this.wxMsgParam)
    },
    onSendSms () {
      magicSendSms(this.smsParam)
    }
  }
}
</script>